<app-enfaf-modal
  [title]="'Añadir ventas manualmente'"
  [buttonCancelText]="'Cancelar'"
  [buttonConfirmText]="'Guardar'"
  [disableConfirmButton]="isSaveDisabled"
  (onClose)="close()"
  (onConfirm)="save()"
  svgIcon="upload-dark"
>
  <section class="add-sales-modal">
    <app-enfaf-input-file-dragger-light
      [fullWidth]="true"
      [accept]="acceptedTypes"
      [acceptMultiple]="false"
      [acceptLimit]="1"
      [disablePreview]="true"
      [title]="'Arrastra y suelta tus archivos aquí'"
      [subtitle]="'CSV, XLS, XLSX'"
      (localFilesUpdated)="onFilesUpdated($event)"
    />

    @if (importedMessages().length) {
      <div class="add-sales-modal__feedback add-sales-modal__feedback--saved" role="status">
        <p class="add-sales-modal__feedback-title add-sales-modal__feedback-title--saved">Se ha guardado esto:</p>
        <ul class="add-sales-modal__feedback-list">
          @for (message of importedMessages(); track $index) {
            <li>{{ message }}</li>
          }
        </ul>
      </div>
    }

    @if (problemMessages().length) {
      <div class="add-sales-modal__feedback" [class.add-sales-modal__feedback--notice]="feedbackTone() === 'notice'" role="alert">
        @if (problemsHeadline()) {
          <p class="add-sales-modal__feedback-title">{{ problemsHeadline() }}</p>
        }
        <ul class="add-sales-modal__feedback-list">
          @for (message of problemMessages(); track $index) {
            <li>{{ message }}</li>
          }
        </ul>
      </div>
    }

    <div class="add-sales-modal__actions">
      <app-enfaf-button type="modal-outline" height="41px" [setNgStyle]="{ 'font-size': '14px', 'max-height': '41px' }" (onClick)="downloadExample()">
        Descargar ejemplo
      </app-enfaf-button>
    </div>
  </section>
</app-enfaf-modal>
